import { render } from "./Loading.vue?vue&type=template&id=6c3dbd40"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=6c3dbd40&lang=css"
script.render = render

export default script